import ApiService from '@/services/ApiService'

export const namespaced = true

export const state = {}

export const mutations = {}

export const actions = {
  uploadFileImportData({ commit }, payload) {
    return ApiService.uploadFileImportData(payload)
      .then(res => {
        const data = res.data
        return data
      })
      .catch(error => {
        throw error
      })
  },
  uploadPayslip({ commit }, payload) {
    return ApiService.uploadPayslip(payload)
      .then(res => {
        const data = res.data
        return data
      })
      .catch(error => {
        throw error
      })
  }
}
